module.exports = __webpack_public_path__ + "static/media/pay-logo.f6e7e70a.svg";